(function () {
  const COMPONENT_SELECTOR = '.home-image-w-text-section slider-component';
  const DOT_ACTIVE_CLASS = 'active';

  function getSlides(component) {
    return Array.from(component.querySelectorAll('.slider__slide[id^="Slide-"]'));
  }

  function getSlider(component) {
    return component.querySelector('[id^="Slider-"]');
  }

  function getNearestSlideIndex(slides, scrollLeft) {
    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  function setActiveDot(component, index) {
    const dots = component.querySelectorAll('.slider-dot');
    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle(DOT_ACTIVE_CLASS, isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function initDots(component, slides, goToIndex) {
    const dotsContainer = component.querySelector('.slider-dots');
    if (!dotsContainer) return;

    dotsContainer.innerHTML = '';

    slides.forEach((_, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'slider-dot';
      button.setAttribute('aria-label', `Go to slide ${index + 1}`);
      button.addEventListener('click', function () {
        goToIndex(index);
      });
      dotsContainer.appendChild(button);
    });
  }

  function initComponent(component) {
    if (component.dataset.homeImageWTextInit === 'true') return;

    const slider = getSlider(component);
    const slides = getSlides(component);
    const prevButton = component.querySelector('button[name="previous"]');
    const nextButton = component.querySelector('button[name="next"]');

    if (!slider || slides.length === 0) return;

    component.dataset.homeImageWTextInit = 'true';

    const loop = component.dataset.loop === 'true';
    const autoplay = component.dataset.autoplay === 'true';
    const autoplayInterval = Number(component.dataset.autoplayInterval || 3000);
    let currentIndex = 0;
    let autoplayTimer = null;

    if (typeof component.enableSliderLooping !== 'undefined') {
      component.enableSliderLooping = loop;
    }

    function normalizedIndex(index) {
      const lastIndex = slides.length - 1;
      if (loop) {
        if (index < 0) return lastIndex;
        if (index > lastIndex) return 0;
      }
      return Math.max(0, Math.min(index, lastIndex));
    }

    function syncButtonsState() {
      if (slides.length < 2) {
        if (prevButton) prevButton.setAttribute('disabled', 'disabled');
        if (nextButton) nextButton.setAttribute('disabled', 'disabled');
        return;
      }

      if (loop) {
        if (prevButton) prevButton.removeAttribute('disabled');
        if (nextButton) nextButton.removeAttribute('disabled');
      }
    }

    function goToIndex(index, behavior) {
      currentIndex = normalizedIndex(index);
      slider.scrollTo({
        left: slides[currentIndex].offsetLeft,
        behavior: behavior || 'smooth',
      });
      setActiveDot(component, currentIndex);
      syncButtonsState();
    }

    function refreshCurrentIndexFromScroll() {
      currentIndex = getNearestSlideIndex(slides, slider.scrollLeft);
      currentIndex = normalizedIndex(currentIndex);
      setActiveDot(component, currentIndex);
      syncButtonsState();
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || slides.length < 2 || autoplayInterval < 500) return;
      autoplayTimer = setInterval(function () {
        goToIndex(currentIndex + 1);
      }, autoplayInterval);
    }

    initDots(component, slides, goToIndex);
    setActiveDot(component, 0);
    syncButtonsState();

    if (loop) {
      const handleNavClick = function (event, step) {
        event.preventDefault();
        event.stopImmediatePropagation();
        goToIndex(currentIndex + step);
        startAutoplay();
      };

      if (prevButton) {
        prevButton.removeAttribute('disabled');
        prevButton.addEventListener(
          'click',
          function (event) {
            handleNavClick(event, -1);
          },
          true
        );
      }

      if (nextButton) {
        nextButton.removeAttribute('disabled');
        nextButton.addEventListener(
          'click',
          function (event) {
            handleNavClick(event, 1);
          },
          true
        );
      }
    }

    slider.addEventListener('scroll', refreshCurrentIndexFromScroll, { passive: true });
    window.addEventListener('resize', refreshCurrentIndexFromScroll, { passive: true });
    component.addEventListener('mouseenter', stopAutoplay);
    component.addEventListener('mouseleave', startAutoplay);
    component.addEventListener('focusin', stopAutoplay);
    component.addEventListener('focusout', startAutoplay);

    goToIndex(0, 'auto');
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll(COMPONENT_SELECTOR).forEach(initComponent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
